// removed by extract-text-webpack-plugin
module.exports = {"section":"c-OrderSection__section","borderBottom":"c-OrderSection__borderBottom","content":"c-OrderSection__content"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/OrderSection/OrderSection.scss
// module id = 460
// module chunks = 0